import React from 'react';
import styles from './item.module.scss';



export function Item(props) {
  const { data, handleClick, checked } = props;

  return (
    <div className={styles['container']}>
      <input
        className={styles['radio-input']}
        type="radio"
        id={data.month}
        name="plans"
        value={data.month.toString()}
        onClick={() => handleClick(data)}
        checked={checked}
      />
      <label
        className={styles['radio-input-lable']}
        htmlFor={data.month.toString()}
      >
        <div className={styles['radio-input-content']}>
          <span className={styles['radio-input-lable-text']}>
            {data.month} months
          </span>
          <span className={styles['radio-input-lable-info']}>
            EGP {data.installment} monthly
          </span>
        </div>
      </label>
    </div>
  );
}

export default Item;
